import { FileImageOutlined } from "@ant-design/icons"
import { Button, message, Upload } from "antd"
import { RcFile } from "antd/es/upload/interface"
import React, { useEffect, useState } from "react"
import { FileUploadDataLP } from "~/types/types"
import { configs } from "../../../configs"
import { t } from "../../../languages/i18n"
import { addMedia } from "../../media/services/apiServices"

interface FileUploadPropsLP {
  fileUploadDataLP: FileUploadDataLP
  setFileUploadDataLP: (data: FileUploadDataLP) => void
}

const FileUploadLP: React.FC<FileUploadPropsLP> = ({ setFileUploadDataLP, fileUploadDataLP }) => {
  const [faviconUrlLP, setFaviconUrlLP] = useState<string | null>(fileUploadDataLP.faviconUrlLP || "")
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setFaviconUrlLP(fileUploadDataLP.faviconUrlLP)
  }, [fileUploadDataLP])

  useEffect(() => {
    setFileUploadDataLP({
      faviconUrlLP,
    })
  }, [faviconUrlLP, setFileUploadDataLP])

  const handleUpload = async (file: RcFile): Promise<boolean> => {
    setLoading(true)
    const formData = new FormData()
    formData.append("files", file)

    try {
      const response = await addMedia(formData)

      if (!response || response.length === 0) {
        throw new Error("No response data")
      }

      setFaviconUrlLP(`${configs.API_URL}${response[0].url}`)
      message.success(t("Favicon uploaded successfully!"))
      return true
    } catch (error) {
      message.error(`Failed to upload favicon: ${error}`)
      return false
    } finally {
      setLoading(false)
    }
  }

  const customRequest = async ({ file, onSuccess, onError }: any) => {
    try {
      const success = await handleUpload(file as RcFile)
      if (success) {
        onSuccess?.()
      } else {
        onError?.(new Error("Upload failed"))
      }
    } catch (error) {
      onError?.(error)
    }
  }

  return (
    <div className="w-full pb-8 border-b flex flex-row justify-between items-center">
      <div>
        <p className="text-base font-semibold">Favicon LandngPage</p>
      </div>
      <div className="flex flex-col gap-2 items-center w-1/3">
        <Upload accept="image/*" customRequest={customRequest} showUploadList={false} disabled={loading}>
          <Button icon={<FileImageOutlined />} loading={loading}>
            {t("Upload Favicon")}
          </Button>
        </Upload>
        {faviconUrlLP && (
          <div className="mt-4">
            <img src={faviconUrlLP} alt="Favicon" className="h-8 w-8 object-contain" />
          </div>
        )}
      </div>
    </div>
  )
}

export default FileUploadLP
